import React from 'react';
import {
  Box, Container, Skeleton, Stack, Typography,
} from '@mui/material';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { InfiniteScroll } from '@marageti/z4-lib';
import AllTripsFilters from './all-filters';
import AllCard from '../../../components/list-cards/trip-match-cards/all-card';

type AllTripsViewProps = {
  countries: string[],
  departureDateFrom: string,
  departureDateTo: string,
  disableSalesStageChips: boolean
  disableSortBy: boolean;
  error?: ApiError,
  hasMoreItems: boolean,
  isLoading: boolean,
  items?: TripMatch[],
  loadMore: () => void,
  matchDateFrom: string,
  matchDateTo: string,
  onChangeFilter: (n: string, v: string | string[]) => void,
  partner: string;
  searchValue: string;
  selectedSalesStageChips: string[];
  selectedStatusChips: string[];
  sortBy: string,
  totalHits: string,
};

const AllTripsView = ({
  partner,
  countries,
  departureDateFrom,
  departureDateTo,
  error = undefined,
  hasMoreItems,
  isLoading,
  items = undefined,
  loadMore,
  matchDateFrom,
  matchDateTo,
  onChangeFilter,
  searchValue,
  selectedStatusChips,
  selectedSalesStageChips,
  sortBy,
  totalHits,
  disableSalesStageChips,
  disableSortBy,
}: AllTripsViewProps) => (
  <Container maxWidth="xl">
    <Box
      sx={{
        mt: {
          desktop: 2.5,
          mobile: 3,
        },
      }}
    >
      <AllTripsFilters
        countries={countries}
        departureDateFrom={departureDateFrom}
        departureDateTo={departureDateTo}
        disableSalesStageChips={disableSalesStageChips}
        disableSortBy={disableSortBy}
        matchDateFrom={matchDateFrom}
        matchDateTo={matchDateTo}
        onChange={onChangeFilter}
        partner={partner}
        searchValue={searchValue}
        selectedSalesStageChips={selectedSalesStageChips}
        selectedStatusChips={selectedStatusChips}
        sortBy={sortBy}
      />
      {isLoading ? (
        <Skeleton variant="rounded" sx={{ mb: 2, height: '24px', width: '100px' }} />
      ) : (
        <Typography variant="bodyBold" mb={2}>
          {`${totalHits === '10,000' ? `${totalHits}+` : totalHits} Result${totalHits === '1' ? '' : 's'}`}
        </Typography>
      )}
      <Stack spacing={1}>
        <InfiniteScroll
          error={error}
          hasMoreItems={hasMoreItems}
          isLoading={isLoading}
          loadMoreItems={loadMore}
        >
          {items?.flatMap((item: TripMatch) => (
            <AllCard
              key={item.id}
              tripMatch={item}
            />
          ))}
        </InfiniteScroll>
      </Stack>
    </Box>
  </Container>
);

export default AllTripsView;
